module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#technology",
      toString: function () {
        return this.url;
      }
    }